<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="add-article-tags-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Add Article Tags
            </h4>
          </div>

          <div class="modal-body">
            <ContentArticleTagsFormGroup
                v-model="tags"
                :portal="portal"
                name="tags"
                label="Tags"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import ContentArticleTagsFormGroup from '@/components/FormGroups/Block/ContentArticleTags'

export default {
  components: {ContentArticleTagsFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    portal: {
      type: Object
    }
  },

  data() {
    return {
      tags: []
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.selected.length) {
        notify.error('No articles selected')
      }

      Promise
          .all(this.selected.map(id => http.post('/api/v2/content-articles/' + id + '/content-article-tags', {
            content_article_tags: this.tags.map(tag => ({name: tag.text}))
          })))
          .then(responses => {
            notify.success('The tags were added')

            responses.map(response => this.$emit('updated', response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.tags = []
    }
  }
}
</script>
